import { Button, Grid2, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Label } from "flowbite-react";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';

const CitySettings = () => {
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));

    const [tokenExpired, setTokenExpired] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [cityFilter, setCityFilter] = useState(cities[0].city_id);

    const [customerSupportNo, setCustomerSupportNo] = useState('');
    const [driverSupportNo, setDriverSupportNo] = useState('');
    const [emergencyNo, setEmergencyNo] = useState('');
    const [supportEmail, setSupportEmail] = useState('');

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const fetchCitySettings = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/settings/client_city_info';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const fetchedData = response.data[0];
                setCustomerSupportNo(fetchedData.customer_support_no);
                setDriverSupportNo(fetchedData.driver_support_no);
                setEmergencyNo(fetchedData.emergency_no);
                setSupportEmail(fetchedData.support_email);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchCitySettings();
    },[cityFilter])

    const saveData = async() =>{
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            customer_support_no: customerSupportNo,
            driver_support_no: driverSupportNo,
            emergency_no: emergencyNo,
            support_email: supportEmail,
            city_id: cityFilter
        };
        // if(scheduleId!=0){
        //     payload.id = scheduleId;
        // }

        try {
            const url = operationsUrl + '/settings/client_city_info';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);

            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                City Settings
            </Typography>

            <Grid2 item sx={{marginTop:'2%'}}>
                <Select value={cityFilter} onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                style={{width: '220px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                    <MenuItem value="">Select City</MenuItem>
                    {cities.map((city) => (
                        <MenuItem key={city.city_name} value={city.city_id}>
                            {city.city_name}
                        </MenuItem>
                    ))}
                </Select>
            </Grid2>

            <Grid2 sx={{margin:"4px", backgroundColor:"#fff", borderRadius:'8px', padding:'12px', marginTop:'12px'}}>

                <Typography sx={{color:'#4E545D', fontSize:'20px'}}> City Settings</Typography>

                <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                    <Grid2 item size={6}>
                        <Label>Customer Support Number<span style={{ color: 'red' }}>*</span></Label>
                        <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                            placeholder="Customer Support Number" fullWidth variant="outlined" type="text" 
                            value={customerSupportNo}
                            onChange={(e) => setCustomerSupportNo(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                        />
                    </Grid2>

                    <Grid2 item size={6}>
                        <Label>Driver Support Number<span style={{ color: 'red' }}>*</span></Label>
                        <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                            placeholder="Driver Support Number" fullWidth variant="outlined" type="text" 
                            value={driverSupportNo}
                            onChange={(e) => setDriverSupportNo(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                        />
                    </Grid2>
                </Grid2>

                <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                    <Grid2 item size={6}>
                        <Label>Emergency Number<span style={{ color: 'red' }}>*</span></Label>
                        <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                            placeholder="Emergency Number" fullWidth variant="outlined" type="text" 
                            value={emergencyNo}
                            onChange={(e) => setEmergencyNo(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                        />
                    </Grid2>

                    {/* <Grid2 item size={6}>
                        <Label>Support Email<span style={{ color: 'red' }}>*</span></Label>
                        <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                            placeholder="Support Email" fullWidth variant="outlined" type="text" 
                            value={supportEmail}
                            onChange={(e) => setSupportEmail(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                        />
                    </Grid2> */}
                </Grid2>

                <Grid2 item sx={{marginTop:'4%', alignItems:'center', justifyContent:'center', display:'flex', marginBottom:'20px'}} size={12}>
                    <Button 
                    onClick={saveData} 
                    variant="contained">Update</Button>
                </Grid2>

            </Grid2>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    )
}

export default CitySettings;